import { render, staticRenderFns } from "./Aboutnew.vue?vue&type=template&id=726f2b39&scoped=true&"
import script from "./Aboutnew.vue?vue&type=script&lang=js&"
export * from "./Aboutnew.vue?vue&type=script&lang=js&"
import style0 from "./Aboutnew.vue?vue&type=style&index=0&id=726f2b39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f2b39",
  null
  
)

export default component.exports